<template>
  <v-container fluid class="px-0 py-0">
    <v-autocomplete
        ref="autocomplite"
        v-if="!!aggregateSelectStore && !!aggregateSelectStore.rootData"
        v-bind="$attrs"
        :value="value"
        dense
        :items="proxyList"
        :multiple="multiple"
        :item-text="itemText"
        item-value="uid"
        :outlined="outlined"
        append-icon="mdi-refresh"
        clearable
        :prepend-icon="prependIcon"
        @click:append="onRefresh()"
        @click:prepend="$emit('click:prepend')"
        @input="onInput($event)"
        @click="onRefresh()"
        :error="error || (this.errorEmpty && !this.value)"
        :background-color="backgroundColor"
    >
      <template v-slot:prepend>
        <slot name="prepend"></slot>
      </template>
    </v-autocomplete>
  </v-container>
</template>

<script>
import {v4 as uuidv4} from "uuid";
import {useAggregateStore, useBaseAggregateStore} from '@/store/CommonStore/baseAggregateStore'
import {useTableStore} from "@/components/Common/CommonTable";
import {debounce} from "debounce";

export default {
  name: "CommonSelectFromTable",

  props: {
    value: {default: null},
    errorEmpty: {default: false},
    items: {default: null},
    itemText: {default: 'name'},
    prependIcon: {default: null},
    dtoListQuery: {type: [String], default: null},
    sortBy: {default: null},
    backgroundColor: {default: null},
    sortDesc: {
      default() {
        return [true]
      }
    },
    storeName: {
      type: [String], default() {
        return uuidv4()
      }
    },
    aggregateSelectStoreName: {
      default() {
        return uuidv4().toString().replace(/-/g, '')
      }
    },
    showSelect: {default: true},
    singleSelect: {default: false},
    multiple: {type: [Boolean], default: false},
    outlined: {type: [Boolean], default: true},
    itemsPerPage: {default: 20},
    queryFilters: {default: null},
  },

  components: {},

  computed: {
    error() {
      return !this.storeSelectedTable.loading && !!this.value && !!this.storeSelectedTable && !(this.storeSelectedTable.uidList.includes(this.value)) &&
          !!this.aggregateStore &&
          !!this.aggregateStore.rootData && (this.value in this.aggregateStore.rootData) &&
          !!this.aggregateStore.rootData[this.value]
    },
    proxyList() {
      if (!!this.error) {
        let storeProxyList = this.storeSelectedTable.proxyList
        let notExistItem = structuredClone(this.aggregateStore.rootData[this.value])
        notExistItem[this.itemText] = '* ' + notExistItem[this.itemText]
        this.storeSelectedTable.proxyList.push(notExistItem)
        return storeProxyList
      } else
        return this.storeSelectedTable.proxyList
    },
  },

  watch: {
    queryFilters: {
      handler(newValue, oldValue) {
        this.storeSelectedTable.query_filters = this.queryFilters
      }
    },
  },
  methods: {
    onRefresh() {
      this.storeSelectedTable.update()
    },
    onInput(uid) {
      if (!(uid in this.aggregateStore.uid_dict))
        this.aggregateStore.uid_dict[uid] = this.aggregateSelectStore.uid_dict[uid]
      if (!(uid in this.aggregateStore.rootData))
        this.aggregateStore.rootData[uid] = this.aggregateSelectStore.rootData[uid]
      this.$emit('input', uid)
    },
  },

  async mounted() {
    // console.log('CommonSelectFromTable mounted', this.storeName)
    this.aggregateStore = useAggregateStore()
    this.aggregateSelectStore = useBaseAggregateStore(this.aggregateSelectStoreName)()
    this.storeSelectedTable = useTableStore(this.storeName, this.aggregateSelectStoreName)()
    this.storeSelectedTable.dtoListQuery = this.dtoListQuery
    this.storeSelectedTable.singleSelect = this.singleSelect
    this.storeSelectedTable.options.itemsPerPage = -1
    this.storeSelectedTable.options.sortBy = this.sortBy
    this.storeSelectedTable.options.sortDesc = this.sortDesc
    this.storeSelectedTable.options.page = 0
    this.storeSelectedTable.query_filters = this.queryFilters
    this.storeSelectedTable.update()
  },

  beforeDestroy() {
    // console.log('beforeDestroy', this.aggregateSelectStoreName, this.storeName)
    this.aggregateSelectStore.$reset()
  },

  data() {
    return {
      aggregateStore: null,
      aggregateSelectStore: null,
      storeTable: null,
    }
  },
}
</script>

<style scoped>

</style>

<i18n src="@/components/Common/locales.json">
</i18n>